'use strict';

var Type = require('../type');

module.exports = new Type('tag:yaml.org,2002:map', {
  kind: 'mapping',
  construct: function (data) { return data !== null ? data : {}; }
});



//////////////////
// WEBPACK FOOTER
// ./~/@kyleshockey/js-yaml/lib/js-yaml/type/map.js
// module id = 634
// module chunks = 0